import React, { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Stack from '@mui/material/Stack';
import Section from 'components/Section';
import TermsSelect from 'components/TermsSelect';

import { PackageEditMainTerms_data$key } from '__generated__/PackageEditMainTerms_data.graphql';

type Props = {
  data: PackageEditMainTerms_data$key;
};

const PackageEditMainTerms: FC<Props> = props => {
  const data = useFragment(
    graphql`
      fragment PackageEditMainTerms_data on Query {
        ...TermsSelect_data
      }
    `,
    props.data
  );

  return (
    <Section id="terms" title="Sąlygos">
      <Stack spacing={4}>
        <TermsSelect
          name="included"
          label="Įskaičiuota į pasiūlymo kainą"
          data={data}
        />

        <TermsSelect
          name="excluded"
          label="Neįskaičiuota į pasiūlymo kainą"
          data={data}
        />
      </Stack>
    </Section>
  );
};

export default PackageEditMainTerms;
